import locale from "./locales/en";
import { blockScreen } from "./common";
import { IAlertProps } from "./types";
import { uid } from "@dhx/ts-common/core";

export function alert(props: IAlertProps) {
	const apply = props.buttons && props.buttons[0] ? props.buttons[0] : locale.apply;

	const unblock = blockScreen(props.blockerCss);

	return new Promise(res => {
		const contentId = `dhx_alert__${uid()}_content`;
		const headerId = `dhx_alert__${uid()}_header`;
		const alertBox = document.createElement("div");
		alertBox.setAttribute("role", "alert");
		alertBox.setAttribute("aria-modal", "true");
		props.text && alertBox.setAttribute("aria-describedby", contentId);
		props.header && alertBox.setAttribute("aria-labelledby", headerId);
		alertBox.className = "dhx_widget dhx_alert " + (props.css || "");

		const closeAlert = e => {
			if (e.key === "Escape" || e.key === "Esc") {
				// eslint-disable-next-line @typescript-eslint/no-use-before-define
				close(e);
				res(false);
			}
		};

		function close(e) {
			e.preventDefault();
			unblock();
			document.body.removeChild(alertBox);
			document.removeEventListener("keydown", closeAlert);
		}

		alertBox.innerHTML = `
			${
				props.header
					? `<div id=${headerId} class="dhx_alert__header"> ${
							props.htmlEnable !== false ? props.header : ""
					  } </div>`
					: ""
			}
			${
				props.text
					? `<div id=${contentId} class="dhx_alert__content">${
							props.htmlEnable !== false ? props.text : ""
					  }</div>`
					: ``
			}
			<div class="dhx_alert__footer ${
				props.buttonsAlignment ? "dhx_alert__footer--" + props.buttonsAlignment : ""
			}">
				<button type="button" aria-label="confirm" class="dhx_alert__apply-button dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium">${apply}</button>
			</div>`;

		if (props.htmlEnable === false) {
			props.header && (alertBox.querySelector(`#${headerId}`).textContent = props.header);
			props.text && (alertBox.querySelector(`#${contentId}`).textContent = props.text);
		}

		document.body.appendChild(alertBox);
		(alertBox.querySelector(".dhx_alert__apply-button") as HTMLElement).focus();

		alertBox.querySelector("button").addEventListener("click", e => {
			close(e);
			res(true);
		});

		document.addEventListener("keydown", closeAlert);
	});
}
